import classNames from 'classnames/bind';
import React, { forwardRef, useEffect, useState } from 'react';
import styles from './ScaleIndicator.module.scss';
import ScoreIcon from '../Static/ScoreIcon';
import OutlookIcon from '../Static/OutlookIcon';
import ScoreEqualOutlookIcon from '../Static/ScoreEqualOutlookIcon';
import { getScoreState } from '../../../../utils/scoreUtils';

const cx = classNames.bind(styles);

interface RiskFactorProps {
  label?: string;
  score: number;
  outlook: number;
}

const ScaleIndicator = ({ label, score, outlook }: RiskFactorProps): React.ReactElement => {
  const [isScoreEqualOutlook, setIsScoreEqualOutlook] = useState<Boolean>(false);
  const [upperLimit, setUpperLimit] = useState<number>(0);
  const [lowerLimit, setLowerLimit] = useState<number>(0);
  const [scoreText, setScoreText] = useState<string>('');
  const [outlookText, setOutlookText] = useState<string>('');

  useEffect(() => {
    if (score > outlook) {
      setUpperLimit(score);
      setLowerLimit(outlook);
    } else if (score < outlook) {
      setUpperLimit(outlook);
      setLowerLimit(score);
    } else {
      setIsScoreEqualOutlook(true);
    }
  }, []);

  useEffect(() => {
    setScoreText(getScoreState(score, `${label?.split(' ')[0].toLocaleLowerCase()}Assessment`));
    setOutlookText(getScoreState(outlook, `${label?.split(' ')[0].toLocaleLowerCase()}Outlook`));
  }, []);

  return (
    <div className={cx('body')}>
      <div className={cx('subfactor-label')}>
        <p>{label}</p>
      </div>
      <div className={cx('subfactor-scale')}>
        {Array.from(Array(5), (element, index: number) => {
          return (
            <div className={cx('subfactor-scale-child')}>
              {index + 1 !== upperLimit &&
                index + 1 !== lowerLimit &&
                !(isScoreEqualOutlook && score === index + 1) && <div className={cx('vertical-line')} />}

              {upperLimit >= index + 1 && lowerLimit < index + 1 && !isScoreEqualOutlook && (
                <div className={cx('connection-line-left')} />
              )}
              {upperLimit > index + 1 && lowerLimit <= index + 1 && !isScoreEqualOutlook && (
                <div className={cx('connection-line-right')} />
              )}
              {!isScoreEqualOutlook && score === index + 1 && (
                <div className={cx('dot-icon-wrapper')}>
                  {' '}
                  <ScoreIcon />
                </div>
              )}
              {!isScoreEqualOutlook && outlook === index + 1 && (
                <div className={cx('dot-icon-wrapper')}>
                  {' '}
                  <OutlookIcon />
                </div>
              )}
              {isScoreEqualOutlook && score === index + 1 && (
                <div className={cx('dot-icon-wrapper')}>
                  {' '}
                  <ScoreEqualOutlookIcon />
                </div>
              )}
            </div>
          );
        })}
      </div>
      <div className={cx('subfactor-scale-print')}>
        <p>{scoreText}</p>
        <p>{outlookText}</p>
      </div>
    </div>
  );
};

export default forwardRef(ScaleIndicator);
